import { useRef } from 'react';
import ConfiguredIntegrationsApi from '../api/configured_integrations';
import StepFunctionExecutionsApi from '../api/step_function_executions';
import authorizeOn from '../utils/resourceAuthorizer';

const useRetryExecutionFunctions = () => {
  const retryExecutionIdRef = useRef(null);

  const executionHasInvalidPayloadError = (execution) =>
    execution.error_summary?.errors?.some((error) => error.status === 400);

  const isRetryButtonVisible = (execution) =>
    authorizeOn() &&
    execution.trigger_type === 'application_event' &&
    execution.status === 'FAILED' &&
    !executionHasInvalidPayloadError(execution);

  const isRetryButtonDisabled = (executions, xDecisivTraceId) =>
    executions.some(
      (execution) =>
        execution.attributes.parent_x_decisiv_trace_id === xDecisivTraceId,
    );

  const handleRetry = async (
    executionId,
    configuredIntegrationUuid,
    refreshCallback,
  ) => {
    retryExecutionIdRef.current = executionId;

    // Slim list row omits invocation_payload; fetch the full record to re-invoke.
    const { data } =
      await StepFunctionExecutionsApi.fetchStepFunctionExecutionById(
        executionId,
      );
    const payload = data?.attributes?.invocation_payload;

    if (payload) {
      await ConfiguredIntegrationsApi.invokeIntegration(
        configuredIntegrationUuid,
        payload,
        'MANUAL_RETRY',
      );
    }

    retryExecutionIdRef.current = null;
    await refreshCallback();
  };

  return {
    isRetryButtonVisible,
    isRetryButtonDisabled,
    handleRetry,
    retryExecutionIdRef,
  };
};

export default useRetryExecutionFunctions;
